import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React, { forwardRef, useState } from 'react';
import useId from '@indeed/ihl-use-id';
import { FORM_SIZES } from '../../constants/index.js';
import { jsx } from '@emotion/react';
import { FormField } from '../FormField/FormField.js';
import { Input } from '../Input/Input.js';
import { CharacterCounter } from '../CharacterCounter/CharacterCounter.js';
import '@indeed/ifl-css';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../../utils/transition.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Text/Text.js';
import '../Box/Box.js';
import '../Flex/Flex.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../../utils/warn.js';
import '../../hooks/useCheckValidity.js';
import '../Input/ChipInput.js';
import '../Input/styles.js';
import '../Input/AutosizeInput.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Chip/ChipGroup.js';
import '../Chip/Chip.js';
import '@emotion/is-prop-valid';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../Button/Button.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/displayName.js';
import '../Input/InputWrapper.js';
import '../TouchTarget/TouchTarget.js';
import '../../hooks/useDebounce.js';

function isReactElement(counter) {
  return counter.type !== undefined;
}
function getCharacterCounter(counter, props) {
  let retVal;
  if (counter) {
    retVal = isReactElement(counter) ? (/*#__PURE__*/React.cloneElement(counter, props)) : jsx(CharacterCounter, _extends({}, counter, props));
  }
  return retVal;
}
const InputFormField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    name,
    inputProps,
    inputRef,
    counter,
    ...props
  } = _ref;
  const {
    onChange,
    ...otherInputProps
  } = inputProps || {};
  const [counterValue, setCounterValue] = useState((otherInputProps.value || otherInputProps.defaultValue || "").length);
  const {
    disabled,
    invalid,
    size
  } = props;
  const defaultId = `ifl-InputFormField-${useId()}`;
  const id = otherInputProps.id || defaultId;
  const autoGeneratedHelperTextId = `ifl-InputFormField-helperTextId-${useId()}`;
  const helperTextId = props.helperTextId || (props.helperText ? autoGeneratedHelperTextId : undefined);
  const autoGeneratedErrorTextId = `ifl-InputFormField-errorTextId-${useId()}`;
  const errorTextId = props.errorTextId || (props.errorText ? autoGeneratedErrorTextId : undefined);
  const ariaDescribedby = ([helperTextId, errorTextId].filter(value => value !== undefined) || []).join(" ");
  const Counter = getCharacterCounter(counter, {
    value: counterValue
  });
  return jsx(FormField, _extends({
    ref: ref,
    htmlFor: id,
    counter: Counter,
    helperTextId: helperTextId,
    errorTextId: errorTextId
  }, props), jsx(Input, _extends({
    id: id,
    ref: inputRef,
    onChange: e => {
      setCounterValue(e.target.value.length);
      if (onChange) {
        onChange(e);
      }
    },
    name: name,
    disabled: disabled,
    invalid: invalid,
    "aria-describedby": ariaDescribedby || undefined,
    size: size
  }, otherInputProps)));
});
const INPUT_FORM_FIELD_SIZES = FORM_SIZES;
InputFormField.displayName = "InputFormField";

export { INPUT_FORM_FIELD_SIZES, InputFormField, getCharacterCounter };
